<!--
    描述：会员详情
    时间：2022-06-22
    Created by zwh
-->
<template>
  <div class="member-detail-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          业务流水号：{{objectForm.bizNumber}}
        </el-col>
        <el-col :span="12">
          流程发起时间：{{objectForm.createDate}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          授权认证流程ID：{{objectForm.flowId}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          授权认证链接地址：{{objectForm.links}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          个人姓名：
        </el-col>
        <el-col :span="12">
          会员类型：{{objectForm.accountTypeText}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          证件类型：{{objectForm.certTypeText}}
        </el-col>
        <el-col :span="12">
          证件号：{{objectForm.certNo}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          手机号：{{objectForm.mobileNo}}
        </el-col>
        <el-col :span="12">
          邮箱：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          银行卡号：{{objectForm.bankCardNo}}
        </el-col>
        <el-col :span="12">
          e签宝会员ID：{{objectForm.accountId}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          业务码（code)：{{objectForm.code}}
        </el-col>
        <el-col :span="12">
          业务数据：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          业务信息：
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import * as API from 'api/modules/es/member_manage'
export default {
  name: "detail",
  data(){
    return {
      objectForm : {
        id : '',  //ID唯一
        bizNumber : '',//业务流水号
        accountId : '',//会员ID
        accountName : '',//会员名称
        accountType : '',//会员类型(码表)
        certType : '',//证件类型(码表)
        certNo : '',//证件号
        mobileNo : '',  //手机号
        flowId : '',//流程ID
        code : '',//业务码
        bizParam : '',//请求之前携带的业务参数 只能为字符串
        bankCardNo : '',//银行卡号
        /**
         * 链接
         */
        links : '',
        createUserid : '',//创建人ID
        createDate : '',//流程发起时间
        updateUserid : '',//更新人ID
        updateDate : '',//认证结束时间
        accountTypeText : '',//会员类型(码表)
        certTypeText : '',//证件类型(码表)
      }
    }
  },
  mounted() {},
  computed: {
    esignUserId() {
      return this.$route.query.id
    },
  },
  created() {
    this.getObjectById()
  },
  methods :{
    getObjectById(){
      let param = {
        id : this.esignUserId
      }
      API.getObjectById(param).then(res=>{
        if(res.operationCode == 1) {
          Object.keys(this.objectForm).forEach(key=> this.objectForm[key] = res.data[key])
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.member-detail-page {
  padding : 20px 50px;

  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }
  }
}
</style>